<template>
  <jet-authentication-card>
    <div class="text-center">
      <h1 class="h1">
        <subdomain-link
          href="/"
          class="f-center contain-svg h-gr-8 w-gr-double-10 px-gr-6 mx-auto text-gray-900"
          v-html="$getSvgHtml('vqp-logo')"
        >
        </subdomain-link>
        <span class="sr-only">Visual Quote PRO</span>
      </h1>
      <p class="mt-gr-4 opacity-50">Coming soon...</p>
    </div>
  </jet-authentication-card>
</template>

<script>
  import JetAuthenticationCard from '@/Jetstream/AuthenticationCard';
  export default {
    props: {},

    components: {
      JetAuthenticationCard,
    },
  };
</script>
